import { useCallback, useMemo } from "react";

import { Container } from "@material-ui/core";
import moment from "moment";

import { ContentSection } from "../../layout/ContentSection";
import { ComplaintTaskDocument } from "../../task/task.model";
import { ListSection, ListSectionProps } from "../../components/admin-list-section/ListSection";
import { sortByCustomerThenDueDate, sortbyDueDateThenCustomer } from "../../shared/utility";
import { ListFormatter } from "../../formatting/list.formatter";

type Task = ComplaintTaskDocument;

interface ContactCustomerTabProps {
    currentTasks: Task[];
    futureTasks: Task[];
    goToTask: (task: Task) => void;
}

export const ContactCustomerTab = (props: ContactCustomerTabProps) => {
    const { currentTasks, futureTasks, goToTask } = props;

    const currentTaskListItems: ListSectionProps["items"] = useMemo(() => {
        return currentTasks.sort(sortByCustomerThenDueDate).map(mapToListItem);
    }, [currentTasks]);

    const goToCurrentTask = useCallback((index: number) => {
        const task = currentTasks[index];

        goToTask(task);
    }, [goToTask, currentTasks]);

    const futureTaskListItems = useMemo(() => {
        return futureTasks.sort(sortbyDueDateThenCustomer).map(mapToListItem);
    }, [futureTasks]);

    const goToFutureTask = useCallback((index: number) => {
        const task = futureTasks[index];

        goToTask(task);
    }, [goToTask, futureTasks]);

    return (
        <ContentSection>
            <Container maxWidth="sm" disableGutters>

                <ListSection
                    title="Aktuelle opgaver"
                    placeholder="Der er ingen aktuelle opgaver"
                    items={currentTaskListItems}
                    onClick={goToCurrentTask}
                />

                <ListSection
                    title="Fremtidige opgaver"
                    placeholder="Der er ingen fremtidige opgaver"
                    items={futureTaskListItems}
                    onClick={goToFutureTask}
                />

            </Container>
        </ContentSection>
    );
};

const mapToListItem = (task: Task): ListSectionProps["items"][0] => {
    const formattedDate = moment(task.performAfterDate).format("D MMMM HH:mm");

    const invoicesListed = new ListFormatter().formatList(task.complaint.invoices.map(invoice => `faktura ${invoice.invoiceNumber}`));

    return {
        heading: `${task.customerName} har reklameret over ${invoicesListed}`,
        subheading: `Skal udføres ${formattedDate}`,
    };
}
